import { COU_httpPost } from '@/utils/http'

// 铺货预览时对图片进行编辑 (白底图和透明图，1688接口)
async function OperateImageTo1688({ imageUrl, formatType }) {
  const url = '/image/segmentCommodity'
  const r = await COU_httpPost({ url, data: { imageUrl, formatType, reType: 2 } })
  let msg, success = false, img
  try {
    msg = r.msg
    success = r.success
    img = r.result
  } 
  catch (error) {
    console.log(error)
  }
  return { success, msg, imageUrl: img }
}

export default {
  OperateImageTo1688
}